module.exports = __webpack_public_path__ + "static/media/permission_to_photos.c9dd104d.png";